export default () => ({
  homeInitialInfo: {
    cantTurnos: 0,
    cantInformesDiagImg: 0,
    cantInformesLab: 0,
    otrosDocumentos: 0,
    cantEpicrisis: 0,
  },
  menuTree: [],
  menuLoading: true,
  menuError: null,
  profileNombre: '',
  profileApellido: '',
  activePortalFichaId: null,
  activePortalNombre: '',
  activePortalParentesco: '',
  informesHome: {
    items: [],
    loading: false,
    error: null,
  },
  informesDiagnosticosPage: {
    items: [],
    loading: false,
    error: null,
  },
  resultadosLaboratorioPage: {
    items: [],
    loading: false,
    error: null,
  },
  otrosDocumentosPage: {
    items: [],
    loading: false,
    error: null,
  },
  admissionsPage: {
    items: [],
    loading: false,
    error: null,
  },
  pedidosMedicosPage: {
    items: [],
    loading: false,
    error: null,
  },
  portalPrivateParams: {
    loading: false,
    fetched: false,
    urlExternaResultadosLaboratorio: null,
    fechaDesdeConsInfIso: '',
    validarAfiliadoAutogestion: null,
    pacienteCargaObservacionesTurnosAutogestion: null,
    limiteAgendaTurnos: null,
    horasValidacionTurnoWeb: null,
    mesesMargenCronogramasVigentesConsultaWeb: null,
    minutosAnticipacionTurnos: 60,
    telefonoTurnoWeb: '',
    emailDeNotificacionesCancelacionClienteWeb: '',
    mjeNotaInicial: '',
    mjePacienteInexistente: '',
    mjePacienteSinOsDisponibleWeb: '',
    noConfirmarAutomaticamenteTurnos: null,
    validaTurnoWeb: null,
    celularObligatorioTurno: null,
    telObligTurnos: null,
    mascaraCelTurno: null,
    mascaraTelTurno: null,
    actualizaFichaDesdeTurnoAutogestion: null,
    mostrarDatosFichaTurnosWeb: null,
    usaModeloIAPP: null,
    permiteAdjuntarArchivo: null,
    cantidadMaximaArchivosAdjuntos: 1,
    permiteTurnoDesdePedidoMedico: false,
    permiteSacarTurno: false,
    permiteTurnoMultiPracticas: false,
    diasVencimientoPedidoMedico: null,
    portalPacienteImplementado: false,
    autogestionImplementada: false,
    error: null,
  },
  turnosPendientes: {
    loading: false,
    items: [],
    error: null,
    fetched: false,
  },
  turnosHistorial: {
    loading: false,
    items: [],
    error: null,
    fetched: false,
  },
})
